import React from "react"
import PropTypes from "prop-types"

const config = {
  AVAILABLE: { "color": "bg-timetable-available", "highlighted": "bg-timetable-available" },
  BOOKED:    { "color": "bg-timetable-booked", "highlighted": "bg-timetable-booked" },
  DISABLED:  { "color": "bg-timetable-disabled", "highlighted": "bg-timetable-highlight-disabled" },
  ABSENT:    { "color": "bg-timetable-absent", "highlighted": "bg-timetable-absent" },
  ATTENDED:  { "color": "bg-timetable-attended", "highlighted": "bg-timetable-attended" },
};

const Slot = ({ 
  handleClick = () => {}, 
  isClickable = false, 
  isHighlighted = false, 
  isMuted = false, 
  group,
  slot, 
  status,
}) => {
  const getCaption = () => {
    if (status === "AVAILABLE") return "--"
    if (status === "DISABLED") return "x"
    return slot?.booking?.student_initials || ""
  }

  const getClasses = () => {
    const slotConfig = config[status] || {};
    const classes = []
    
    if (isClickable) classes.push("cursor-pointer")
    if (isHighlighted) classes.push(slotConfig.highlighted)
    if (isMuted) classes.push("bg-timetable-muted")
    if (!isHighlighted && !isMuted) classes.push(slotConfig.color)

    return classes.join(" ")
  }

  const caption = getCaption()
  const classes = getClasses()
  
  return (
    <div className={`timetable__slot ${classes}`} onClick={() => isClickable ? handleClick(group,slot, status, isClickable) : {}}>
      {caption}
    </div>
  )
}

Slot.propTypes = {
  handleClick: PropTypes.func,
  isClickable: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  isMuted: PropTypes.bool,
  status: PropTypes.string.isRequired,
  slot: PropTypes.shape({
    id: PropTypes.string.isRequired,
    starts_at: PropTypes.string.isRequired,
    ends_at: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    booking: PropTypes.shape({
      id: PropTypes.string.isRequired,
      student_initials: PropTypes.string.isRequired,
      booking_slot_id: PropTypes.string.isRequired,
      student_id: PropTypes.string.isRequired,
    }),
    group: PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  }).isRequired,
}

export default React.memo(Slot, (prev, next) => {
  return (
    prev.isClickable === next.isClickable &&
    prev.isHighlighted === next.isHighlighted &&
    prev.isMuted === next.isMuted &&
    prev.status === next.status &&
    prev.handleClick === next.handleClick &&
    prev.slot.id === next.slot.id &&
    (prev.slot.booking?.student_initials ?? "") === (next.slot.booking?.student_initials ?? "")
  )
})